import { useMutation, useQueryClient } from '@tanstack/react-query';

import { confirmSinglePropertyDetails } from '../service';

type UseConfirmSinglePropertyDetailsOpts = {
    onSuccess?: () => void;
    onError?: (error: Error) => void;
};

function useConfirmSinglePropertyMutation(
    propertyId: string | number,
    opts: UseConfirmSinglePropertyDetailsOpts = {}
) {
    const queryClient = useQueryClient();

    const query = useMutation({
        mutationFn: () => confirmSinglePropertyDetails(
            propertyId
        ),
        onSuccess: () => {
            void queryClient.invalidateQueries({
                queryKey: ['update-properties'],
            });

            void queryClient.invalidateQueries({
                queryKey: ['property', propertyId],
            });

            if (opts.onSuccess !== undefined) {
                opts.onSuccess();
            }
        },
        onError: (error) => {
            if (opts.onError !== undefined) {
                opts.onError(error);
            }
        },
    });

    return query;
}

export { useConfirmSinglePropertyMutation };
